module.exports = __webpack_public_path__ + "static/media/asma.5982df1d.jpg";